module.exports = __webpack_public_path__ + "static/media/5.de776b5b.jpg";